module.exports = __webpack_public_path__ + "static/sewa-rural-0bf826d7001e2fbb98d54209e41184a2.jpeg";